<template>
  <div class="detail-page">
    <div class="null-content" v-if="detail==null">
      <div class="text"><i class="el-icon-guide"></i>未找到该文章</div>
    </div>
    <div class="detail" v-else>
      <el-image style="width:100%" :src="detail.image" fit="fill"></el-image>
      <div class="blog-title">{{detail.title}}</div>
      <div v-html="detail.content" class="content"></div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      detail: {}
    }
  },
  methods: {
    getBlogDetail (id) {
      const that = this
      that.axios.get('blog/' + id).then(function (resp) {
        if (resp.data.detail !== null) {
          that.detail = resp.data.detail
        } else {
          that.detail = null
        }
        that.content = resp.data
      })
    }
  },
  mounted () {
    if (this.$route.params.id !== undefined) {
      this.getBlogDetail(this.$route.params.id)
    }
  }
}
</script>

<style scoped>
.detail-page{
  max-width: 1000px;
  margin: 50px auto;
}
.null-content{
  margin: auto;
  text-align: center;
  font-size: 40px;
  font-weight: 300;
  line-height: 60px;
  padding: 200px 15px;
}
.content{
  line-height: 30px;
  font-size: 17px;
  color: #595f5f;
}
.blog-title{
  font-size: 30px;
  font-weight: 600;
  padding: 50px 0 30px;
}
.content >>> figure {
    text-align: center;
}
.content >>> img{
  width: 100%;
}
</style>
